import { ENV } from '../../env';
import { Country } from '@calo/types';

export const getGif = ({ country, name }: { country: Country; name: string }) =>
  `${ENV.CDN_URL}/gif-content/${country}/${name}.gif`;
